import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as TeamApi from "../../services/team.service"
import { Link, useNavigate, useParams } from "react-router-dom";
import { formateDate } from "../../../../utils/commonfunction";
import Breadcrums from "../../common/breadcrumbs";
import { Placeholder } from "rsuite";

const TeamDetails = () => {
    const params = useParams();
    const { t } = useTranslation();
    const [showdefault, setShowDefault] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("Team Management"), url: "/admin/team-management/team/list/1" },
        { title: t("btn_view"), url: "" },
    ];

    useEffect(() => {
        setIsLoading(true);
        TeamApi.Details(params.id)
            .then((response) => {
                setShowDefault(response?.data || {});
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [params.id]);

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12">
                    <div className="card custom-card">
                        <div className="card-body">
                            <h6 className="main-content-label mb-3">
                                Team Management View
                            </h6>
                            {isLoading ? (
                                <Placeholder.Paragraph active rows={7} />
                            ) : showdefault && Object.keys(showdefault).length > 0 ? (
                                <>
                                    {/* ================= BASIC MATCH INFO ================= */}
                                    <table className="table table-bordered table-hover">
                                        <tbody>
                                            <tr>
                                                <th>{t("label_name")}</th>
                                                <td>{showdefault?.name || "N/A"}</td>
                                            </tr>
                                            <tr>
                                                <th>{t("label_image")}</th>
                                                <img
                                                    style={{
                                                        borderRadius: "50%"
                                                    }}
                                                    src={showdefault?.image} width="40" height="40" />
                                            </tr>
                                        </tbody>
                                    </table>

                                    {/* ================= PLAYERS INFO ================= */}
                                    <h6 className="main-content-label mb-3">{t("label_players_info")}</h6>
                                    <table className="table table-bordered table-hover mt-4">
                                        <thead>
                                            <tr>
                                                <th>{t("list_heading_sno")}</th>
                                                <th>{t("label_name")}</th>
                                                <th>{t("label_position")}</th>
                                                <th>{t("label_image")}</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {showdefault?.playersIds?.length ? (
                                                showdefault.playersIds.map((player, i) => (
                                                    <tr key={i}>
                                                        <td
                                                            style={{
                                                                width: "80px"
                                                            }}
                                                        >{i + 1}</td>
                                                        {/* Name*/}
                                                        <td>
                                                            <Link
                                                                to={`/admin/user-management/players/view/${player?.id}`}
                                                                style={{ color: "inherit", textDecoration: "none" }}
                                                            >
                                                                {player && player?.name ? player?.name : "N/A"}
                                                            </Link>
                                                        </td>
                                                        {/* Position */}
                                                        <td>
                                                            {player?.position
                                                                ? player.position
                                                                    .map(role =>
                                                                        role
                                                                            .replace("_", " ")
                                                                            .replace(/\b\w/g, c => c.toUpperCase())
                                                                    )
                                                                    .join(", ")
                                                                : "N/A"}
                                                        </td>
                                                        {/* Image */}
                                                        <td>
                                                            <img
                                                                src={player?.image}
                                                                width="40"
                                                                height="40"
                                                                style={{ borderRadius: "50%" }}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="3" className="text-center">
                                                        <p>No Data Found</p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>

                                    {/* BACK BUTTON */}
                                    <div className="mt-5">
                                        <button
                                            className="btn ripple btn-dark"
                                            type="button"
                                            onClick={() => navigate(-1)}
                                        >
                                            <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                            {t("btn_back")}
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <Placeholder.Paragraph active rows={7} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TeamDetails;